<template>
  <div>
    <vs-button type="border" color="secondary" @click="showPopup = true">{{ label }}</vs-button>
    <popup-select893 v-model="showPopup" @select="onSelect"/>
  </div>
</template>

<script>
import PopupSelect893 from "@/views/boards/single-page/893/PopupSelect893.vue";

export default {
  components: { PopupSelect893 },
  props: {
    value: Object,
    label: {
      type: String,
      default: "에너지검토 분류 선택"
    }
  },
  computed: {
    model: {
      get () {
        return this.value;
      },
      set (val) {
        if (val) {
          this.$emit('input', {
            id: val.id,
            사업장: val.body.사업장,
            팀명: val.body.팀명,
            공장명: val.body.공장명,
            공정명: val.body.공정명,
            상태: val.body.상태,
            활동명: val.body.활동명,
          });
          return;
        }
        this.$emit('input', val);
      }
    }
  },
  data () {
    return {
      showPopup: false
    }
  },
  methods: {
    onSelect (model) {
      this.model = model;
    }
  }
}
</script>

<style scoped>

</style>
